import React from "react";
import HireMeIcon from "../icons/HireMeIcon";
import MagneticWrapper from "./Magnetic";
import {motion} from "framer-motion";

function HireMeButton() {
    return (
        <div className="fixed right-4 bottom-4 flex items-center justify-center overflow-hidden lg1:left-auto lg1:right-8 lg1:top-0 lg1:bottom-auto lg1:hidden z-40">
            <div className="w-48 h-auto flex items-center justify-center relative lg1:w-24">
                <MagneticWrapper>
                    <HireMeIcon className={"fill-dark animate-spin-slow dark:fill-light"} />
                    <motion.a
                        href="mailto:kailashjobmail007@gmail.com"
                        className="flex items-center justify-center
                            absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2
                            bg-dark text-light shadow-sm border border-solid border-dark w-20 h-20 rounded-full
                            font-semibold hover:bg-light hover:text-dark
                            dark:bg-light dark:text-dark hover:dark:bg-dark hover:dark:text-light
                            hover:dark:border-light lg1:w-12 lg1:h-12 lg1:text-[10px]
                        "
                    >
                        Hire Me
                    </motion.a>
                </MagneticWrapper>
            </div>
        </div>
    );
}

export default HireMeButton;
